import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/context/auth/AuthContext';
import { useCareerPath } from '@/context/CareerContext';
import { useCareerPathDetails } from '@/context/CareerPathContext';

interface Goal {
  id: string;
  title: string;
  completed: boolean;
  dueDate?: string;
}

export function useCareerProgress() {
  const { user } = useAuth();
  const { careerPath } = useCareerPath();
  const { pathDetails, setPathDetails } = useCareerPathDetails();
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState({
    weeklyGoals: [] as Goal[],
    completedGoals: 0,
    totalGoals: 0,
    careerCoins: 0
  });

  useEffect(() => {
    if (user?.id) {
      fetchProgress();
    }
  }, [user?.id]);

  const fetchProgress = async () => {
    try {
      const { data: profile } = await supabase
        .from('user_profiles')
        .select('career_coins, goals, completed_goals')
        .eq('user_id', user?.id)
        .single();

      if (profile) {
        const goals = (profile.goals || []) as Goal[];
        const completedGoals = (profile.completed_goals || []) as Goal[];

        setProgress({
          weeklyGoals: goals,
          completedGoals: completedGoals.length,
          totalGoals: goals.length,
          careerCoins: profile.career_coins || 0
        });
      }
    } catch (error) {
      console.error('Error fetching career progress:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    ...progress,
    refreshProgress: fetchProgress
  };
} 